export default __webpack_public_path__ + "static/healthcare-a0e994bfd185e6fcb827010b517560a6.png";